import { supabase } from "@/lib/supabaseClient";
import type { WordSet } from "@/types/models";

/** 전체 단어장 카테고리 조회 (정렬순) */
export async function getWordSets(): Promise<WordSet[]> {
  const { data, error } = await supabase.from("word_sets").select("*").order("sort_order");

  if (error) {
    throw error;
  }
  return data;
}

/** 무료 단어장만 조회 */
export async function getFreeWordSets(): Promise<WordSet[]> {
  const { data, error } = await supabase.from("word_sets").select("*").eq("is_free", true).order("sort_order");

  if (error) {
    throw error;
  }
  return data;
}
